import { Component, OnInit, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import {
  QaiFieldComponent,
  QaiFloatingDirective,
  QaiIconComponent,
  QaiInputComponent,
  QaiPasteCleanDirective,
  QaiTooltipComponent,
  QaiTrimLeadingDirective,
} from '@qai/ui';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@jsverse/transloco';
import { AuthorReactiveFormService } from 'src/app/pages/self-serve/simulation-builder/services/author-reactive-form.service';

@Component({
  selector: 'knowledge-check-question-fields',
  standalone: true,
  templateUrl: './knowledge-check-question-fields.component.html',
  styleUrls: ['./knowledge-check-question-fields.component.scss'],
  imports: [
    ReactiveFormsModule,
    QaiFieldComponent,
    QaiInputComponent,
    QaiTrimLeadingDirective,
    QaiPasteCleanDirective,
    QaiIconComponent,
    QaiTooltipComponent,
    QaiFloatingDirective,
    TranslocoModule,
  ],
  providers: [{ provide: TRANSLOCO_SCOPE, useValue: 'simulationBuilder' }],
})
export class KnowledgeCheckQuestionFieldsComponent implements OnInit {
  questionForm = input.required<FormGroup>();

  callUuid: string = '';

  constructor(
    private route: ActivatedRoute,
    private authorReactiveFormService: AuthorReactiveFormService,
  ) {}

  ngOnInit(): void {
    this.callUuid = this.route.snapshot.paramMap?.get('uuid')!;
    ['script', 'hint', 'resourceNote'].forEach((controlName) =>
      this.authorReactiveFormService.setReadOnlyMode(
        this.callUuid,
        this.questionForm().get(controlName),
      ),
    );
  }
}
